import React from "react";
import { Box, Typography } from "@mui/material";
import { formatParamsForDisplay } from "./apiLogDisplayUtils";

interface ApiLogParamsSectionProps {
  title: string;
  params?: Record<string, string>;
  revealSensitive?: boolean;
}

function ApiLogParamsSection({ title, params, revealSensitive = false }: ApiLogParamsSectionProps) {
  const entries = formatParamsForDisplay(params, { revealSensitive });
  if (entries.length === 0) return null;

  return (
    <Box>
      <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 1 }}>
        {title}
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "minmax(140px, 34%) 1fr" },
          columnGap: 2,
          rowGap: 1.25,
          p: 2,
          bgcolor: "action.hover",
          borderRadius: 1,
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        {entries.map((entry) => (
          <React.Fragment key={entry.key}>
            <Typography variant="body2" color="text.secondary">
              {entry.label}
            </Typography>
            <Typography variant="body2" fontWeight={600} sx={{ wordBreak: "break-word" }}>
              {entry.value}
            </Typography>
          </React.Fragment>
        ))}
      </Box>
    </Box>
  );
}

export default ApiLogParamsSection;
